import React from 'react';
import PropTypes from 'prop-types';
import { ShieldCheck, Lock, UsersRound } from 'lucide-react';

const SecurityModule = ({ className = '' }) => (
  <div className={`bg-white border border-blue-200/60 shadow-sm rounded-2xl p-6 mb-8 ${className}`}>
    <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
      <div className="flex flex-col items-center text-center py-4 md:py-0 md:px-4">
        <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
          <ShieldCheck size={20} className="text-blue-500" />
        </div>
        <h3 className="font-medium text-slate-700 mt-3 mb-1">Secure</h3>
        <p className="text-xs text-slate-400 leading-relaxed">
          256-bit encryption
          <br />
          Bank-level data protection
        </p>
      </div>

      <div className="flex flex-col items-center text-center py-4 md:py-0 md:px-4">
        <div className="w-10 h-10 bg-purple-50 rounded-xl flex items-center justify-center">
          <Lock size={20} className="text-purple-600" />
        </div>
        <h3 className="font-medium text-slate-700 mt-3 mb-1">Compliant</h3>
        <p className="text-xs text-slate-400 leading-relaxed">
          Operating in 40+ states
          <br />
          Your data is handled securely
        </p>
      </div>

      <div className="flex flex-col items-center text-center py-4 md:py-0 md:px-4">
        <div className="w-10 h-10 bg-green-50 rounded-xl flex items-center justify-center">
          <UsersRound size={20} className="text-green-500" />
        </div>
        <h3 className="font-medium text-slate-700 mt-3 mb-1">Trusted</h3>
        <p className="text-xs text-slate-400 leading-relaxed">
          200,000+ borrowers served
          <br />
          4k+ 5★ reviews
        </p>
      </div>
    </div>
  </div>
);

SecurityModule.propTypes = {
  className: PropTypes.string,
};

SecurityModule.defaultProps = {
  className: '',
};

export default SecurityModule;
